import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/contact/ContactPageClient.tsx")